import { forwardRef } from 'react';
import { IconButton as ChakraIconButton, type IconButtonProps } from '@chakra-ui/react';

/**
 * An icon button, round unless the call site says otherwise.
 *
 * The shape lives here rather than in the theme because Chakra's `IconButton` is `Button` with its
 * padding taken off — there is no icon-button recipe to give a default to, and a `base` on the
 * button recipe would reach every text button in the app. Left to call sites the radius was written
 * out by hand 52 times and forgotten in a handful more, which is the job a default exists to do.
 *
 * `borderRadius` sits before the spread, so a site that wants another shape passes one and wins.
 */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(props, ref) {
	return <ChakraIconButton borderRadius="full" ref={ref} {...props} />;
});

export type { IconButtonProps };
